import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.645 20.9101L11.638 20.9071L11.616 20.8951C11.4873 20.8243 11.3596 20.7516 11.233 20.6771C9.71081 19.7726 8.28828 18.71 6.989 17.5071C4.688 15.3601 2.25 12.1741 2.25 8.25007C2.25 5.32207 4.714 3.00007 7.688 3.00007C8.51475 2.99602 9.33178 3.17841 10.0783 3.53368C10.8249 3.88894 11.4817 4.40794 12 5.05207C12.5184 4.40781 13.1754 3.88873 13.9221 3.53346C14.6689 3.17819 15.4861 2.99587 16.313 3.00007C19.286 3.00007 21.75 5.32207 21.75 8.25007C21.75 12.1751 19.312 15.3611 17.011 17.5061C15.7117 18.709 14.2892 19.7716 12.767 20.6761C12.6404 20.7509 12.5127 20.8239 12.384 20.8951L12.362 20.9071L12.355 20.9111L12.352 20.9121C12.2436 20.9695 12.1227 20.9995 12 20.9995C11.8773 20.9995 11.7564 20.9695 11.648 20.9121L11.645 20.9101Z"
        fill={colorValue}
      />
    </svg>
  );
};
